import type { TooltipProps } from '@mui/material';
import { Box, Tooltip } from '@mui/material';
import React, { forwardRef } from 'react';
import { IconOnlyButton } from './icon-only-button';
import type { IconOnlyButtonProps } from './icon-only-button';
export interface IconButtonProps extends Omit<IconOnlyButtonProps, 'children' | 'startIcon' | 'endIcon'> {
  /** The icon. */
  children: React.ReactNode;
  /** Names the button for screen readers and shows as its tooltip. */
  label: string;
  /** Where the `label` tooltip opens. */
  tooltipPlacement?: TooltipProps['placement'];
  /** Keeps the tooltip closed, e.g. while the button's own popup is open. */
  hideTooltip?: boolean;
}

/**
 * An icon-only button with Button's variants, colors and sizes. `label` is
 * required: it is the accessible name and the tooltip.
 */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton({
  children,
  label,
  tooltipPlacement,
  hideTooltip = false,
  ...rest
}, ref) {
  const button = <IconOnlyButton ref={ref} aria-label={label} {...rest}>
        {children}
      </IconOnlyButton>;
  return <Tooltip title={hideTooltip ? '' : label} placement={tooltipPlacement}>
        {/* A disabled button fires no pointer events, so the tooltip listens
            on a wrapper instead. */}
        {rest.disabled ? <Box component="span" sx={{
      display: 'inline-flex'
    }}>
            {button}
          </Box> : button}
      </Tooltip>;
});